import { combineReducers } from 'redux'

import businessesReducer from '../../../shared_slices/businessesSlice'
import serviceCategoriesReducer from '../../../shared_slices/serviceCategoriesSlice'
import locationsReducer from '../../../shared_slices/locationsSlice'
import staffReducer from '../../../shared_slices/staffSlice'

export default combineReducers({
  business: businessesReducer,
  serviceCategories: serviceCategoriesReducer,
  locations: locationsReducer,
  staff: staffReducer
})
